import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import styled from "styled-components";
import {
  Form,
  Input,
  Button,
  message,
  Checkbox,
  Modal,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { confirm } = Modal;

const DashboardStyle = styled.div`
  margin-left: 280px;
  overflow-x: hidden;
`;

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BillingPage = () => {
  const [addManagerForm] = Form.useForm();
  const [managers, setManagers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { token } = useAuth();

  const fetchManagers = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/companies/manager/details/billing`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setManagers(res.data.managers);
    } catch (error) {
      message.error("Failed to load company managers.");
    }
  };

  useEffect(() => {
    fetchManagers();
  }, []);

  const handleAddManager = async (values) => {
    try {
      await axios.post(
        `${BASE_URL}/companies/manager/details/inoice/add`,
        {
          email: values.email,
          receives_invoice_email: true,
          role: values.role,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Email added successfully.");
      addManagerForm.resetFields();
      setIsModalVisible(false);
      fetchManagers();
    } catch (err) {
      message.error("Failed to add manager.");
    }
  };

  const handleDelete = (email) => {
    confirm({
      title:
        "Are you sure you want to remove this manager email? This action cannot be undone",
      icon: <ExclamationCircleOutlined />,
      content: email,
      okText: "Delete Email",
      cancelText: "Cancel",
      okButtonProps: {
        style: {
          backgroundColor: "#3c2f61",
          color: "white",
        },
      },
      onOk: async () => {
        try {
          await axios.delete(
            `${BASE_URL}/companies/manager/details/invoice/delete`,
            {
              headers: { Authorization: `Bearer ${token}` },
              data: { email },
            }
          );
          message.success("Manager removed.");
          fetchManagers();
        } catch (error) {
          message.error("Failed to delete manager.");
        }
      },
    });
  };

  return (
    <DashboardStyle>
      <div className="content-container">
        <br />
        <div className="col">
          <h3>Billing</h3>
          <br />
        </div>
        <main
          className="main-content border-radius-lg card container-fluid"
          style={{ padding: "23px" }}
        >
          {/* Placeholder Section */}
          <div className="row mb-4">
            <div className="col-12">
              <p style={{ color: "grey", fontStyle: "italic" }}>
                No invoices found
              </p>
            </div>
          </div>

          {/* Managers Section */}
          <div style={{ marginTop: "2rem" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h6 style={{ color: "#5e95ff" }}>
                Managers Receiving Monthly Invoice Emails
              </h6>
              <Tooltip title="Add Email">
                <Button
                  type="primary"
                  shape="circle"
                  icon={<PlusOutlined />}
                  onClick={() => setIsModalVisible(true)}
                />
              </Tooltip>
            </div>

            <div style={{ marginTop: "1rem" }}>
              {managers.map((manager) => (
                <div
                  key={manager.email}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                    borderBottom: "1px solid #f0f0f0",
                    paddingBottom: "5px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox checked={manager.receives_invoice_email} />
                    <span style={{ marginLeft: "0.5rem" }}>
                      {manager.email}{" "}
                      <span style={{ color: "grey" }}>({manager.role})</span>
                    </span>
                  </div>
                  {!manager.is_acc_manager && (
                    <Tooltip title="Remove Manager">
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(manager.email)}
                      />
                    </Tooltip>
                  )}
                </div>
              ))}
            </div>
          </div>
        </main>

        <Modal
          title="Add Manager to Receive Invoice Emails"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          onOk={() => addManagerForm.submit()}
          okText="Submit"
          okButtonProps={{
            style: {
              backgroundColor: "#3c2f61",
              color: "white",
            },
          }}
        >
          <Form
            form={addManagerForm}
            layout="vertical"
            onFinish={handleAddManager}
          >
            <Form.Item
              name="email"
              label="Manager Email"
              rules={[
                { required: true, message: "Email is required" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input placeholder="manager@example.com" />
            </Form.Item>

            <Form.Item
              name="role"
              label="Role"
              rules={[{ required: true, message: "Role is required" }]}
            >
              <Input
                placeholder="e.g., Finance"
                onChange={(e) => {
                  const value = e.target.value
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                  addManagerForm.setFieldsValue({ role: value });
                }}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </DashboardStyle>
  );
};

export default BillingPage;
